export function getFlags(flags) {
    return { type: 'GET_FLAGS', flags };
}
